module.exports = __webpack_public_path__ + "img/dgvlogo.0a12c239.png";